/* USERS */
export const ADD_USER = "ADD_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_CLEAN = "ADD_USER_CLEAN"
export const ADD_USER_ERROR = "ADD_USER_ERROR"
